// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 height=%2762.5%27 width=%27116.9%27 fill=%27%23161f27%27%3E%3Cpath d=%27M115.3 1.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1L7.4 1.6C5.8 0 3.2 0 1.6 1.6 0 3.2 0 5.8 1.6 7.4l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-style {
  --white: #fff;
  --grey: #e6e6e6;
  --dirty-grey: #5c5653;
  --black: #262626;
  --green: #2fa152;
  --blue: rgb(0, 120, 212);
  --purple: #512da8;
  --orange: #a46313;
  --red: #c84427;
  --red-lighter-text: #7c2020;
  --red-lighter-bg: #ffeded;
  --primary: var(--blue);
  --secondary: var(--green);
  --background: #fff;
  --background-alt: #f8fafc;
  --selection: #9e9e9e;
  --text-main: #4a4a4a;
  --text-bright: #000;
  --text-muted: #707070;
  --links: var(--primary);
  --focus: rgba(74, 105, 189, 0.35);
  --border: rgba(0, 0, 0, 0.2);
  --border-radius: 4px;
  --code: #000;
  --animation-duration: 0.1s;
  --button-shadow: none;
  --form-placeholder: #949494;
  --form-text: #000;
  --select-arrow: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  --accent-border: 0;
  --accent-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

fieldset.lt-style {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-inline: var(--default-gutter, 2rem);
  padding-block: 0.5rem;
  border: 0;
}

fieldset.lt-style > input.lt-style:not([type="checkbox"]):not([type="radio"]),
fieldset.lt-style > select.lt-style,
fieldset.lt-style > div {
  flex: 1;
  min-width: 240px;
}

fieldset.lt-style > label {
  flex: 0 0 240px;
  padding-block: 0.4rem;
  padding-inline-end: 1rem;
  font-size: 0.9rem;
  font-weight: 600;
}

fieldset.lt-style .lt-style {
  margin-block: 0;
}

button.lt-style,
input.lt-style,
textarea.lt-style {
  transition: all var(--animation-duration) ease;
}

button.lt-style,
select.lt-style,
input.lt-style[type="submit"],
input.lt-style[type="button"],
input.lt-style[type="checkbox"],
input.lt-style[type="range"],
input.lt-style[type="radio"] {
  line-height: 1em;
  cursor: pointer;
  white-space: nowrap;
}

input.lt-style:not([type="checkbox"]):not([type="radio"]),
select.lt-style {
  display: block;
}

input.lt-style,
button.lt-style,
textarea.lt-style,
select.lt-style,
details.lt-style > summary {
  color: var(--form-text);
  background-color: var(--background);

  font-family: inherit;
  font-size: 14px;

  position: relative;
  margin-block: 0.5rem;
  padding: 8px 16px;
  width: 100%;

  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  outline: none;

  appearance: none;
}

button.lt-style + button.lt-style {
  margin-left: 0.5rem;
}

textarea.lt-style {
  margin-right: 0;
  width: 100%;
  resize: vertical;
}

select.lt-style {
  background: var(--background) var(--select-arrow) calc(100% - 12px) 50% / 12px
    no-repeat;
  padding-block: 0;
  line-height: 38px;
  padding-right: 35px;
}

select.lt-style::-ms-expand {
  display: none;
}

select.lt-style[multiple] {
  padding-right: 10px;
  background-image: none;
  overflow-y: auto;
}

button.lt-style,
input.lt-style[type="submit"],
input.lt-style[type="button"],
input.lt-style[type="reset"] {
  padding-right: 14px;
  padding-left: 14px;
  width: auto;
  min-width: none;
  flex: 0 0 auto;

  background-color: var(--btn-bg, var(--primary));
  color: var(--btn-c, var(--white));
  box-shadow: var(--button-shadow);
  font-weight: 600;
}

button.lt-style.lt-white,
input.lt-style.lt-white [type="submit"],
input.lt-style.lt-white [type="button"],
input.lt-style.lt-white [type="reset"] {
  color: var(--black);
  background-color: var(--white);
}

button.lt-style.lt-green,
input.lt-style.lt-green [type="submit"],
input.lt-style.lt-green [type="button"],
input.lt-style.lt-green [type="reset"] {
  background-color: var(--green);
}

button.lt-style.lt-purple,
input.lt-style.lt-purple [type="submit"],
input.lt-style.lt-purple [type="button"],
input.lt-style.lt-purple [type="reset"] {
  background-color: var(--purple);
  transition: all var(--animation-duration) ease;
}

button.lt-style.lt-purple:disabled {
  color: var(--purple-lighter);
  transition: all var(--animation-duration) ease;
}

button.lt-style.lt-purple-lighter,
input.lt-style.lt-purple-lighter [type="submit"],
input.lt-style.lt-purple-lighter [type="button"],
input.lt-style.lt-purple-lighter [type="reset"] {
  color: var(--purple);
  border: 1px solid var(--purple);
  background-color: var(--white);
}

button.lt-style.lt-grey-lighter,
input.lt-style.lt-grey-lighter [type="submit"],
input.lt-style.lt-grey-lighter [type="button"],
input.lt-style.lt-grey-lighter [type="reset"] {
  color: var(--dirty-grey);
  background-color: var(--white);
  border: 1px solid var(--dirty-grey);
}
button.lt-style.lt-orange,
input.lt-style.lt-orange [type="submit"],
input.lt-style.lt-orange [type="button"],
input.lt-style.lt-orange [type="reset"] {
  background-color: var(--orange);
}

button.lt-style.lt-red-lighter,
input.lt-style.lt-red-lighter [type="submit"],
input.lt-style.lt-red-lighter [type="button"],
input.lt-style.lt-red-lighter [type="reset"] {
  color: var(--red-lighter-text);
  border: 1px solid var(--red-lighter-text);
  background-color: var(--red-lighter-bg);
}

button.lt-style.lt-red,
input.lt-style.lt-red [type="submit"],
input.lt-style.lt-red [type="button"],
input.lt-style.lt-red [type="reset"] {
  background-color: var(--red);
}

button.lt-style:hover,
input.lt-style[type="submit"]:hover,
input.lt-style[type="button"]:hover {
  box-shadow: inset 0 0 3rem rgba(0, 0, 0, 0.1);
}

input.lt-style:not([readonly]):hover,
select.lt-style:not([readonly]):hover,
textarea.lt-style:not([readonly]):hover {
  border-color: rgba(100, 100, 100, 0.75);
}

input.lt-style[type="checkbox"]:active,
input.lt-style[type="radio"]:active,
input.lt-style[type="submit"]:active,
input.lt-style[type="button"]:active,
input.lt-style[type="range"]:active,
button.lt-style:active {
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.1)
  );
}

input.lt-style:focus,
select.lt-style:focus,
textarea.lt-style:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 1px var(--focus);
}

input.lt-style[type="checkbox"],
input.lt-style[type="radio"] {
  position: relative;
  width: 20px;
  min-width: auto;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  padding: 1px;
  margin-block: 0.3rem;
  margin-right: 2px;
  flex: 0 0 auto;
}

input.lt-style[type="radio"] {
  border-radius: 50%;
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.4), inset 0 0 0 4px #fff;
}

input.lt-style[type="checkbox"]:checked,
input.lt-style[type="radio"]:checked {
  background: var(--primary);
}

input.lt-style[type="checkbox"]:checked::before {
  display: flex;
  justify-content: center;

  content: "✔";

  color: white;
  font-size: 0.8rem;
}

input.lt-style[type="range"] {
  padding: 0;
}

input.lt-style[type="color"] {
  padding: 2px;
  width: 5rem;
  height: 2.5rem;
}

input.lt-style:disabled,
select.lt-style:disabled,
button.lt-style:disabled,
textarea.lt-style:disabled {
  cursor: not-allowed;
  opacity: 0.4;
  background: #f5f4f3;
}

.lt-style::placeholder {
  color: var(--form-placeholder);
}

legend.lt-style {
  font-size: 0.9rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/lt-style/lt-style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;EACjB,uDAAwV;;EAExV,kBAAkB;EAClB;sCACoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;EACrB,SAAS;AACX;;AAEA;;;EAGE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;EAKE,uBAAuB;EACvB,mCAAmC;;EAEnC,oBAAoB;EACpB,eAAe;;EAEf,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;;EAEX,+BAA+B;EAC/B,mCAAmC;EACnC,aAAa;;EAEb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;aACW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;;EAEd,+CAA+C;EAC/C,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;;;;EAIE,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;EAIE,wBAAwB;EACxB,8BAA8B;EAC9B,mCAAmC;AACrC;AACA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,8BAA8B;EAC9B,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;;;;EAME;;;GAGC;AACH;;AAEA;;;EAGE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;;EAEvB,YAAY;;EAEZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".lt-style {\n  --white: #fff;\n  --grey: #e6e6e6;\n  --dirty-grey: #5c5653;\n  --black: #262626;\n  --green: #2fa152;\n  --blue: rgb(0, 120, 212);\n  --purple: #512da8;\n  --orange: #a46313;\n  --red: #c84427;\n  --red-lighter-text: #7c2020;\n  --red-lighter-bg: #ffeded;\n  --primary: var(--blue);\n  --secondary: var(--green);\n  --background: #fff;\n  --background-alt: #f8fafc;\n  --selection: #9e9e9e;\n  --text-main: #4a4a4a;\n  --text-bright: #000;\n  --text-muted: #707070;\n  --links: var(--primary);\n  --focus: rgba(74, 105, 189, 0.35);\n  --border: rgba(0, 0, 0, 0.2);\n  --border-radius: 4px;\n  --code: #000;\n  --animation-duration: 0.1s;\n  --button-shadow: none;\n  --form-placeholder: #949494;\n  --form-text: #000;\n  --select-arrow: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='62.5' width='116.9' fill='%23161f27'%3E%3Cpath d='M115.3 1.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1L7.4 1.6C5.8 0 3.2 0 1.6 1.6 0 3.2 0 5.8 1.6 7.4l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z'/%3E%3C/svg%3E\");\n\n  --accent-border: 0;\n  --accent-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\nfieldset.lt-style {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  padding-inline: var(--default-gutter, 2rem);\n  padding-block: 0.5rem;\n  border: 0;\n}\n\nfieldset.lt-style > input.lt-style:not([type=\"checkbox\"]):not([type=\"radio\"]),\nfieldset.lt-style > select.lt-style,\nfieldset.lt-style > div {\n  flex: 1;\n  min-width: 240px;\n}\n\nfieldset.lt-style > label {\n  flex: 0 0 240px;\n  padding-block: 0.4rem;\n  padding-inline-end: 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\nfieldset.lt-style .lt-style {\n  margin-block: 0;\n}\n\nbutton.lt-style,\ninput.lt-style,\ntextarea.lt-style {\n  transition: all var(--animation-duration) ease;\n}\n\nbutton.lt-style,\nselect.lt-style,\ninput.lt-style[type=\"submit\"],\ninput.lt-style[type=\"button\"],\ninput.lt-style[type=\"checkbox\"],\ninput.lt-style[type=\"range\"],\ninput.lt-style[type=\"radio\"] {\n  line-height: 1em;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\ninput.lt-style:not([type=\"checkbox\"]):not([type=\"radio\"]),\nselect.lt-style {\n  display: block;\n}\n\ninput.lt-style,\nbutton.lt-style,\ntextarea.lt-style,\nselect.lt-style,\ndetails.lt-style > summary {\n  color: var(--form-text);\n  background-color: var(--background);\n\n  font-family: inherit;\n  font-size: 14px;\n\n  position: relative;\n  margin-block: 0.5rem;\n  padding: 8px 16px;\n  width: 100%;\n\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius);\n  outline: none;\n\n  appearance: none;\n}\n\nbutton.lt-style + button.lt-style {\n  margin-left: 0.5rem;\n}\n\ntextarea.lt-style {\n  margin-right: 0;\n  width: 100%;\n  resize: vertical;\n}\n\nselect.lt-style {\n  background: var(--background) var(--select-arrow) calc(100% - 12px) 50% / 12px\n    no-repeat;\n  padding-block: 0;\n  line-height: 38px;\n  padding-right: 35px;\n}\n\nselect.lt-style::-ms-expand {\n  display: none;\n}\n\nselect.lt-style[multiple] {\n  padding-right: 10px;\n  background-image: none;\n  overflow-y: auto;\n}\n\nbutton.lt-style,\ninput.lt-style[type=\"submit\"],\ninput.lt-style[type=\"button\"],\ninput.lt-style[type=\"reset\"] {\n  padding-right: 14px;\n  padding-left: 14px;\n  width: auto;\n  min-width: none;\n  flex: 0 0 auto;\n\n  background-color: var(--btn-bg, var(--primary));\n  color: var(--btn-c, var(--white));\n  box-shadow: var(--button-shadow);\n  font-weight: 600;\n}\n\nbutton.lt-style.lt-white,\ninput.lt-style.lt-white [type=\"submit\"],\ninput.lt-style.lt-white [type=\"button\"],\ninput.lt-style.lt-white [type=\"reset\"] {\n  color: var(--black);\n  background-color: var(--white);\n}\n\nbutton.lt-style.lt-green,\ninput.lt-style.lt-green [type=\"submit\"],\ninput.lt-style.lt-green [type=\"button\"],\ninput.lt-style.lt-green [type=\"reset\"] {\n  background-color: var(--green);\n}\n\nbutton.lt-style.lt-purple,\ninput.lt-style.lt-purple [type=\"submit\"],\ninput.lt-style.lt-purple [type=\"button\"],\ninput.lt-style.lt-purple [type=\"reset\"] {\n  background-color: var(--purple);\n  transition: all var(--animation-duration) ease;\n}\n\nbutton.lt-style.lt-purple:disabled {\n  color: var(--purple-lighter);\n  transition: all var(--animation-duration) ease;\n}\n\nbutton.lt-style.lt-purple-lighter,\ninput.lt-style.lt-purple-lighter [type=\"submit\"],\ninput.lt-style.lt-purple-lighter [type=\"button\"],\ninput.lt-style.lt-purple-lighter [type=\"reset\"] {\n  color: var(--purple);\n  border: 1px solid var(--purple);\n  background-color: var(--white);\n}\n\nbutton.lt-style.lt-grey-lighter,\ninput.lt-style.lt-grey-lighter [type=\"submit\"],\ninput.lt-style.lt-grey-lighter [type=\"button\"],\ninput.lt-style.lt-grey-lighter [type=\"reset\"] {\n  color: var(--dirty-grey);\n  background-color: var(--white);\n  border: 1px solid var(--dirty-grey);\n}\nbutton.lt-style.lt-orange,\ninput.lt-style.lt-orange [type=\"submit\"],\ninput.lt-style.lt-orange [type=\"button\"],\ninput.lt-style.lt-orange [type=\"reset\"] {\n  background-color: var(--orange);\n}\n\nbutton.lt-style.lt-red-lighter,\ninput.lt-style.lt-red-lighter [type=\"submit\"],\ninput.lt-style.lt-red-lighter [type=\"button\"],\ninput.lt-style.lt-red-lighter [type=\"reset\"] {\n  color: var(--red-lighter-text);\n  border: 1px solid var(--red-lighter-text);\n  background-color: var(--red-lighter-bg);\n}\n\nbutton.lt-style.lt-red,\ninput.lt-style.lt-red [type=\"submit\"],\ninput.lt-style.lt-red [type=\"button\"],\ninput.lt-style.lt-red [type=\"reset\"] {\n  background-color: var(--red);\n}\n\nbutton.lt-style:hover,\ninput.lt-style[type=\"submit\"]:hover,\ninput.lt-style[type=\"button\"]:hover {\n  box-shadow: inset 0 0 3rem rgba(0, 0, 0, 0.1);\n}\n\ninput.lt-style:not([readonly]):hover,\nselect.lt-style:not([readonly]):hover,\ntextarea.lt-style:not([readonly]):hover {\n  border-color: rgba(100, 100, 100, 0.75);\n}\n\ninput.lt-style[type=\"checkbox\"]:active,\ninput.lt-style[type=\"radio\"]:active,\ninput.lt-style[type=\"submit\"]:active,\ninput.lt-style[type=\"button\"]:active,\ninput.lt-style[type=\"range\"]:active,\nbutton.lt-style:active {\n  background-image: linear-gradient(\n    rgba(255, 255, 255, 0.1),\n    rgba(255, 255, 255, 0.1)\n  );\n}\n\ninput.lt-style:focus,\nselect.lt-style:focus,\ntextarea.lt-style:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 1px var(--focus);\n}\n\ninput.lt-style[type=\"checkbox\"],\ninput.lt-style[type=\"radio\"] {\n  position: relative;\n  width: 20px;\n  min-width: auto;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 1px;\n  margin-block: 0.3rem;\n  margin-right: 2px;\n  flex: 0 0 auto;\n}\n\ninput.lt-style[type=\"radio\"] {\n  border-radius: 50%;\n  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.4), inset 0 0 0 4px #fff;\n}\n\ninput.lt-style[type=\"checkbox\"]:checked,\ninput.lt-style[type=\"radio\"]:checked {\n  background: var(--primary);\n}\n\ninput.lt-style[type=\"checkbox\"]:checked::before {\n  display: flex;\n  justify-content: center;\n\n  content: \"✔\";\n\n  color: white;\n  font-size: 0.8rem;\n}\n\ninput.lt-style[type=\"range\"] {\n  padding: 0;\n}\n\ninput.lt-style[type=\"color\"] {\n  padding: 2px;\n  width: 5rem;\n  height: 2.5rem;\n}\n\ninput.lt-style:disabled,\nselect.lt-style:disabled,\nbutton.lt-style:disabled,\ntextarea.lt-style:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n  background: #f5f4f3;\n}\n\n.lt-style::placeholder {\n  color: var(--form-placeholder);\n}\n\nlegend.lt-style {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
